import React from 'react'

const GameHeaderLiveData = ({
  crr = '',
  rrr = '',
  minRemainingOvers = '',
  isLimitedOvers,
  lastNForInnings = {}
}) => {
  return (
    <div className="gp__cricket__statistics">
    { 
      crr &&
        <div className="gp__cricket__stat">
          <div className="gp__cricket__stat__title">
            <h3 className="gp__cricket__title gp__cricket__title--desktop">Current Run Rate</h3>
            <h3 className="gp__cricket__title gp__cricket__title--mobile">CRR</h3>
          </div>
          <p>{crr}</p>
        </div>
      || null
    }
    {
      //show RRR when isLimitedOvers flag is true
      rrr && isLimitedOvers && rrr > 0 &&
        <div className="gp__cricket__stat">
          <div className="gp__cricket__stat__title">
            <h3 className="gp__cricket__title gp__cricket__title--desktop">Required Run Rate</h3>
            <h3 className="gp__cricket__title gp__cricket__title--mobile">RRR</h3>
          </div>
          <p>{rrr}</p>
        </div>
      || null
    }
    {
      //if isLimitedOvers flag is true do not show the minRemainingOvers value
      minRemainingOvers && minRemainingOvers > 0 && !isLimitedOvers &&
        <div className="gp__cricket__stat">
          <div className="gp__cricket__stat__title">
            <h3 className="gp__cricket__title gp__cricket__title--desktop">Minimum Ov. Rem</h3>
            <h3 className="gp__cricket__title gp__cricket__title--mobile">Min. Ov. Rem</h3>
          </div>
          <p>{minRemainingOvers}</p>
        </div>
      || null
    }
    {
      lastNForInnings && lastNForInnings.showModule &&
        <div className="gp__cricket__stat gp__cricket__stat--full">
          <div className="gp__cricket__stat__title">
            <h3 className="gp__cricket__title gp__cricket__title--desktop">Last {lastNForInnings.duration} Ov (Run Rate)</h3>
            <h3 className="gp__cricket__title gp__cricket__title--mobile">Last {lastNForInnings.duration} Ov (RR)</h3>
          </div>
          <p>{`${lastNForInnings.runs}/${lastNForInnings.wickets} ${lastNForInnings.rr ? '(' + lastNForInnings.rr + ')' : ''}`}</p>
        </div>
      || null
    }
    </div>
  )
}

export default GameHeaderLiveData



// WEBPACK FOOTER //
// ../app/components/gamepackage/cricket/GameHeaderLiveData.jsx